var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.chip)?_c(_setup.VChip,{class:_setup.chip.color,attrs:{"dark":"","small":""}},[_vm._v(" "+_vm._s(_setup.chip.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }